'use client';

import { motion } from 'framer-motion';
import { Contact } from "@/components/contact";
import { Footer } from "@/components/footer";
import { Mail, MessageSquare, Phone, Send } from 'lucide-react';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-background text-foreground dark:bg-black dark:text-white pt-8 flex flex-col transition-colors duration-300">
      <main className="flex-grow pt-16 pb-16 px-6 relative overflow-hidden">
        {/* Background Decorative Elements */}
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-purple-900/10 rounded-full blur-[120px] -z-10 opacity-50 dark:opacity-100" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-blue-900/10 rounded-full blur-[120px] -z-10 opacity-50 dark:opacity-100" />

        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left Side: Copy */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl md:text-7xl font-black mb-4 tracking-tight pt-16">
              Let&apos;s <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-cyan-600 dark:from-purple-400 dark:to-cyan-400">Connect</span>
            </h1>
            <p className="text-xl text-muted-foreground  max-w-lg leading-relaxed dark:text-gray-400">
            • Have a question about a project?  <br />
            • Or a custom request?</p> <br />
              <p>
              Drop a message and let&apos;s bring your vision to the Digital Universe.
            </p>

            <div className="space-y-6 pt-12 mt-4">
              <div className="text-sm uppercase tracking-wider text-muted-foreground">
                Connect with a message
              </div>
              <div className="flex items-center gap-8">
                <div className="p-3 rounded-lg bg-card border border-border group-hover:border-purple-500/50 transition-colors dark:bg-white/5 dark:border-white/10">
                  <Mail className="w-6 h-6 text-purple-600 dark:text-purple-400" />
                </div>
                <div className="p-3 rounded-lg bg-card border border-border group-hover:border-cyan-500/50 transition-colors dark:bg-white/5 dark:border-white/10">
                  <MessageSquare className="w-8 h-8 text-cyan-600 dark:text-cyan-400" />
                </div>
                <div className="p-3 rounded-lg bg-card border border-border group-hover:border-blue-500/50 transition-colors dark:bg-white/5 dark:border-white/10">
                  <Phone className="w-6 h-6 text-blue-600 dark:text-blue-400" />
                </div>
                <div className="p-3 rounded-lg bg-card border border-border group-hover:border-emerald-500/50 transition-colors dark:bg-white/5 dark:border-white/10">
                  <Send className="w-6 h-6 text-emerald-600 dark:text-emerald-400" />
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Side: Form */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative flex justify-center lg:justify-end"
          >
            <div className="absolute inset-0 bg-gradient-to-tr from-purple-500/10 to-cyan-500/10 rounded-[2.5rem] blur-3xl -z-10" />
            <div className="bg-card/30 backdrop-blur-2xl border border-border/50 p-8 md:p-12 rounded-[2.5rem] shadow-2xl dark:bg-white/[0.02] dark:border-white/10 w-full max-w-lg">
              <Contact />
            </div>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
